###*
  * Controller binds together all the modules
###

class INTENT.report.Controller

  constructor: () ->
    @code = 'report'
    @attr = 'data-' + @code
    @el = $ "[#{@attr}]"
    unless @el and @el.length
      return

    @language = get_language()
    @metadata = @el.data("#{@code}-metadata")
    unless @metadata
      return

    @tableData = null;

    @fields_title = @el.data("#{@code}-fields-title")
    @groups_title = @el.data("#{@code}-groups-title")
    @dataset_select = @el.find('select[name="dataset"]').eq(0)
    @current_dataset_code = @dataset_select.val()

    @datasets = {}
    for dataset_orig in @metadata
      code = dataset_orig.name
      fields = []
      key_fields = []

      for field_code of dataset_orig.key_fields
        key_fields.push field_code

      for field_code of dataset_orig.value_fields
        fields.push field_code

      @datasets[code] =
        name: dataset_orig.display_name[@get_language()]
        fields: fields
        key_fields: key_fields
        groups: dataset_orig.groups || []
        exclude_from_default: dataset_orig.exclude_from_default || []
        relations: dataset_orig.relations || {}
        defaults: dataset_orig.defaults || {}
        time_enabled: dataset_orig.time_enabled
        default_timezone: dataset_orig.default_timezone
        disable_timezone_select: dataset_orig.disable_timezone_select
        cancel_support: dataset_orig.cancel_support || no

    @init_events()

    @renderer = new INTENT.report.Renderer @
    @settingsManager = new INTENT.report.SettingsManager @
    @presetManager = new INTENT.report.PresetManager @
    @dataManager = new INTENT.report.DataManager @

  get_language: () =>
    @language

  get_dataset: (dataset_code) =>
    dataset_code = dataset_code || @get_dataset_code()
    @datasets[dataset_code]

  get_dataset_code: () =>
    @current_dataset_code

  set_dataset_code: (new_code) =>
    if new_code and @current_dataset_code != new_code
      @current_dataset_code = new_code
      presetManager = new INTENT.report.PresetManager @
      presetManager.reset_hash_fields()
      $(document).trigger("#{@code}:dataset_changed", @current_dataset_code);
      @dataset_select.val(new_code).trigger('change')

  get_fields_by_preset: (dataset_code) =>
    dataset_code = dataset_code || @get_dataset_code()
    fields = @get_dataset(dataset_code).fields
    presetManager = new INTENT.report.PresetManager @
    if presetManager?
      preset_fields = presetManager.get_preset_fields(dataset_code)
      fields_by_preset = [];
      for field in fields
        if field in preset_fields
          fields_by_preset.push(field)
      return fields_by_preset
    else
      return fields

  get_group_name: (group_code) =>
    return __('report.config_popup.groups.other') if group_code is '#'
    @groups_title[group_code] and @groups_title[group_code][@language] or group_code

  get_field_name: (field_code) =>
    @fields_title[field_code] and @fields_title[field_code][@language] or field_code

  get_fields: (dataset_code, type = 'key') =>
    return if type is 'key' then @get_dataset(dataset_code).key_fields else @get_fields_by_preset(dataset_code)

  get_fields_list: (dataset_code, type = 'key') =>
    dataset_code = dataset_code || @get_dataset_code()
    fields = if type is 'key' then @get_dataset(dataset_code).key_fields else @get_fields_by_preset(dataset_code)
    fields_list = []
    for code in fields
      fields_list.push({
        id: code,
        text: @get_field_name code
      })
    return fields_list

  sort_report: (key, direction) =>
    index = @tableData.data.fields.indexOf key
    if index == -1
      @controller.show_report()

    sortedData = @tableData.data.data.sort (a, b) =>
      a = a[index].toString().replace(/ /g,'').replace('%','')
      b = b[index].toString().replace(/ /g,'').replace('%','')
      if language == 'en'
        a = a.replace(/,/g,'')
        b = b.replace(/,/g,'')
      else
        a = a.replace(',','.')
        b = b.replace(',','.')
      if $.isNumeric(a) and $.isNumeric(b)
        a = parseFloat(a)
        b = parseFloat(b)
      if a > b
        return if direction == 'asc' then 1 else -1;
      if a < b
        return if direction == 'asc' then -1 else 1;
      return 0;

    @tableData.data.data = sortedData
    @tableData.query.order =
      key: key,
      direction: direction
    settings = @settingsManager.get_settings()
    @settingsManager.remember_settings settings
    @transform_settings_for_datamanager settings
    @renderer.render @tableData

  show_report: () =>
    presets = @presetManager.get_preset_fields()
    settings = @settingsManager.get_settings()
    settings.values = presets
    @settingsManager.remember_settings settings
    @transform_settings_for_datamanager settings
    @dataManager.load_report settings, @renderer.render

  download_report: () =>
    settings = @settingsManager.get_settings()
    @settingsManager.remember_settings settings
    @transform_settings_for_datamanager settings
    @dataManager.download_report settings

  transform_settings_for_datamanager: (settings)=>
    delete settings.period
    settings.start = @settingsManager.periodManager.get_start_date()
    settings.end = @settingsManager.periodManager.get_end_date()

  init_events: () =>
    @dataset_select.on 'change', (e) =>
      new_code = $(e.currentTarget).val()
      if new_code and @current_dataset_code != new_code
        @set_dataset_code new_code

    $(document).on 'click', "[#{@attr}-action='show']", (e) =>
      @show_report()

    $(document).on 'click', "[#{@attr}-action='download']", (e) =>
      @download_report()

    $(document).on 'ajaxStart', (e) =>
      @lock_actions()

    $(document).on 'ajaxStop', (e) =>
      @unlock_actions()

  lock_actions: () =>
    $("[#{@attr}-action]").addClass('disabled').attr('disabled', 'disabled')

  unlock_actions: () =>
    $("[#{@attr}-action]").removeClass('disabled').removeAttr('disabled')

$ ->
  new INTENT.report.Controller
